import { DefaultAlertDialog } from '~/common/components/defaultUIComponents/defaultAlertDialog';
import { useDeleteOrderedProject } from '~/common/api/orderingServiceApi/OrderingApi';

export function DeleteOrderedProjectModal(props: {
  orderedProjectId: number;
  open: boolean;
  toggle: () => void;
}) {
  const { mutate: deleteOrderedProject } = useDeleteOrderedProject({
    onSuccess: props.toggle,
  });

  return (
    <DefaultAlertDialog
      dialogHeaderText="ordertile.modal.deleteOrder.dialogHeaderText"
      dialogBodyText="ordertile.modal.deleteOrder.dialogBodyText"
      isOpen={props.open}
      onConfirmedAction={() =>
        void deleteOrderedProject({ id: props.orderedProjectId })
      }
      onCancel={props.toggle}
    />
  );
}
